<div class="progress-number-wrapper" [class]="sizeClass()">
    <span
        class="progress-number"
        [style]="gradientStyle()"
        [attr.aria-valuenow]="clampedValue()"
        [attr.aria-valuemin]="0"
        [attr.aria-valuemax]="100"
        role="progressbar"
    >
        {{ clampedValue() | percentageValue: 2 : "-" : "" }}<span class="percent-sign">%</span>
    </span>

    @if (label()) {
        <span class="progress-label">{{ label() | translate }}</span>
    }
</div>
